module.exports = __webpack_public_path__ + "static/media/it.22b99ae7.svg";